import { Component, OnInit, Input, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable, startWith, map } from 'rxjs';

@Component({
  selector: 'tools-multi-nav-category-select',
  templateUrl: './multi-nav-category-select.component.html',
  styleUrls: ['./multi-nav-category-select.component.scss']
})
export class MultiNavCategorySelectComponent implements OnInit {
  @Input() navItems: any;
  @Input() showLoading: boolean = false;
  @Input() ShowHeader: boolean = true;
  @Input() showTooltips: boolean = true;
  @Input() minimize: boolean = true;
  @Input() showSearch: boolean = false;

  searchControl = new UntypedFormControl('')
  filteredItems: Observable<any[]>;
  
  items: any[];
  hasHiddenOnMobile: boolean = false;

  constructor(
    public changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.items = this.navItems["Items"].filter(item => {
      return !item["Restricted"];
    }) as [];
    this.filteredItems = this.searchControl.valueChanges.pipe(
      startWith(''),
      map((value: any) => this._filter(value || ''))
    )
    this.updateMobileHiddenItems();
  }

  private _filter(value: any): any[]{
    const filterValue = value.toLowerCase();

    return this.items.filter(option => option.Description.toLowerCase().includes(filterValue));
  }

  navClicked(eve) {
    if (this.showLoading && eve != null) {
      eve["loading"] = true;
    }
  }

  updateMobileHiddenItems() {
    this.hasHiddenOnMobile = false;
    this.items.forEach(element => {
      if (element["MobileHidden"] === true) {
        this.hasHiddenOnMobile = true;
      }
    });
  }

  refresh(list) {
    this.navItems["Items"] = list;
    this.navItems["Items"].sort((a,b) => a.Description.localeCompare(b.Description));
    this.items = list.filter(item => {
      return !item["Restricted"];
    }) as [];

    this.updateMobileHiddenItems();
    this.changeDetectorRef.detectChanges();
  }
}
